import { render, staticRenderFns } from "./StartSurvey.vue?vue&type=template&id=b25269f4"
import script from "./StartSurvey.vue?vue&type=script&lang=js"
export * from "./StartSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports